import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
export const context = createContext({
    opened: false,
    control: void 0,
    state: 'init',
    toggle: () => { },
    registerControl: () => { },
    content: { current: null },
    registerContent: () => { },
});
export function useDropdown() {
    return useContext(context);
}
function useMouseOver(node, handlerIn, handlerOut) {
    useEffect(() => {
        if (!node) {
            return;
        }
        node.addEventListener('mouseenter', handlerIn);
        node.addEventListener('mouseleave', handlerOut);
        return () => {
            node.removeEventListener('mouseenter', handlerIn);
            node.removeEventListener('mouseleave', handlerOut);
        };
    }, [node, handlerIn, handlerOut]);
}
export function useDropdownHover({ open = 0, close = 0, contentHoverPreserve = true, } = {}) {
    const { toggle, opened, registerControl, content } = useDropdown();
    const control = useRef(null);
    const openTimer = useRef();
    const closeTimer = useRef();
    const triggerOpen = useCallback(() => {
        if (closeTimer.current) {
            clearTimeout(closeTimer.current);
        }
        openTimer.current = setTimeout(() => {
            if (!opened) {
                toggle();
            }
        }, open);
    }, [open, opened, toggle]);
    const triggerClose = useCallback(() => {
        if (openTimer.current) {
            clearTimeout(openTimer.current);
        }
        closeTimer.current = setTimeout(() => {
            if (opened) {
                toggle();
            }
        }, close);
    }, [close, opened, toggle]);
    const handleContentMouseIn = useCallback(() => {
        if (contentHoverPreserve && closeTimer.current) {
            clearTimeout(closeTimer.current);
        }
    }, [contentHoverPreserve]);
    const handleContentMouseOut = useCallback(() => {
        if (contentHoverPreserve) {
            triggerClose();
        }
    }, [contentHoverPreserve, triggerClose]);
    useEffect(() => {
        if (!control.current) {
            return;
        }
        registerControl(control.current);
    }, [registerControl, control]);
    useMouseOver(control.current, triggerOpen, triggerClose);
    useMouseOver(content.current, handleContentMouseIn, handleContentMouseOut);
    return {
        opened,
        control,
    };
}
export function useIsIos() {
    const [isSafariMobile, setIsSafariMobile] = useState(typeof window === 'undefined' ? false : /iPhone;/gi.test(window.navigator.userAgent));
    useEffect(() => setIsSafariMobile(/iPhone;/gi.test(window.navigator.userAgent)), []);
    return isSafariMobile;
}
//# sourceMappingURL=utils.js.map